var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"num-row"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"num-item"},[_c('span',[_vm._v(_vm._s(item.num))]),_c('h4',[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }